export const CLIENT_ROUTE = '/song-stats';
export const API_ROUTE = '/api/notification';
export const CLIENT_TITLE = 'Дууны тоолуур';